









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Img extends Vue {
  @Prop({ required: true })
  src: string;

  @Prop({ required: true })
  alt: string;

  @Prop({ default: null })
  height: string;

  @Prop({ default: null })
  width: string;

  @Prop({ default: '' })
  extraClass: string;

  get imageSrc() {
    return this.src ? require(`@/assets/image/${this.src}.svg`) : '';
  }
}
